import React, { FC } from 'react';

import AllocatorProfileShowPageContainer from '@buyside/components/container/AllocatorProfileShow/AllocatorProfileShowPageContainer';
import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';

const AllocatorProfileShowPageRoot: FC<{ allocatorProfileId: string }> = ({
  allocatorProfileId
}) => {
  if (!allocatorProfileId) return;

  return (
    <ErrorBoundary pageName="the allocator profile">
      <AllocatorProfileShowPageContainer allocatorProfileId={parseInt(allocatorProfileId)} />
    </ErrorBoundary>
  );
};

export default AllocatorProfileShowPageRoot;
